import { render, staticRenderFns } from "./ViewCore.vue?vue&type=template&id=6b9d2298&scoped=true"
import script from "./ViewCore.vue?vue&type=script&lang=js"
export * from "./ViewCore.vue?vue&type=script&lang=js"
import style0 from "./ViewCore.vue?vue&type=style&index=0&id=6b9d2298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9d2298",
  null
  
)

export default component.exports